module.exports = __webpack_public_path__ + "img/bg-section-10.1887ed08.svg";